















































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import AuthLogin from '@/components/auth/auth-login.vue';
import ViewpointSelector from '@/components/common/viewpoint-selector.vue';
import { ViewpointDao } from "@/api/ViewpointDao";
import { getModule } from "vuex-module-decorators";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import UserAuth from "@/store/auth/UserAuth";
import { Component, Watch } from "vue-property-decorator";
import FavouritesModule from "@/store/Favourites";

let apiDao: ViewpointDao = new ViewpointDao();

@Component({
  components: {
    'auth-login': AuthLogin,
    ViewpointSelector,
  }
})
export default class AppNav extends Vue {

  private drawer = false
  private MENU_ITEMS = [
    {
      title: 'MLS® Search',
      icon: 'search',
      path: '',
      authPath: 'mls',
      unAuthPath: 'mls',
      count: 0,
      authRequired: false
    },
    {
      title: 'Your Favourites',
      icon: 'favorite',
      path: '',
      authPath: 'favorites',
      unAuthPath: 'benefits',
      count: 0,
      authRequired: true
    },
  ]

  get menuItems() {
    let menuItems: any[] = []
    for (const item of this.MENU_ITEMS) {
      switch (item.title) {
        case 'Your Favourites':
          item['count'] = this.favoritesCount;
          break;
        case 'Viewpoints':
          item['count'] = this.allViewpointsCount;
          break;
      }
      menuItems.splice(menuItems.length, 0, item)
    }
    return menuItems
  }


  get allViewpointsCount(): number {
    let viewpoints = getModule(ViewpointsModule).viewpoints;
    return viewpoints ? viewpoints.length : 0
  }

  get favoritesCount(): number {
    return getModule(FavouritesModule).favouriteIds.length
  }

  get isLoggedIn(): any {
    return getModule(UserAuth).user != null;
  }

  get buttonStyle(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return 'buttonTight';
      default:
        return '';
    }
  }

  get selectedViewpoint() {
    return getModule(ViewpointsModule).selectedViewpoint
  }

  get viewpoints() {
    return getModule(ViewpointsModule).viewpoints
  }

  viewpointSelected(viewpointId: string) {
    getModule(ViewpointsModule).selectViewpoint(viewpointId)
  }

  openDrawer() {
    this.drawer = true;
  }

}

